export default __webpack_public_path__ + "static/media/triple.076e4a86.svg";